import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CanEditGuard} from '../../../guards/can-edit.guard';
import {AuthorizeGuard} from '../../../repositories/authorize-guard.service';
import {DocumentViewerComponent} from '../../document-viewer/document-viewer.component';
import * as stages from '../stages';
import {WorkspaceComponent} from '../workspace.component';

const routes: Routes = [
  {
    path: 'workspace',
    component: WorkspaceComponent,
    canActivate: [
      AuthorizeGuard,
      CanEditGuard
    ],
    children: [
      {path: 'purpose-type', outlet: 'stages', component: stages.PurposeTypePageComponent},
      {path: 'account-type', outlet: 'stages', component: stages.AccountTypeComponent},
      {path: 'joint-info', outlet: 'stages', component: stages.JointInfoMobileComponent},
      {path: 'personal', outlet: 'stages', component: stages.PersonalSingleComponent},
      {path: 'address', outlet: 'stages', component: stages.AddressSingleComponent},
      {path: 'employment', outlet: 'stages', component: stages.EmploymentSingleComponent},
      {path: 'personal-first-holder', outlet: 'stages', component: stages.PersonalFirstHolderComponent},
      {path: 'address-first-holder', outlet: 'stages', component: stages.AddressFirstHolderComponent},
      {path: 'employment-first-holder', outlet: 'stages', component: stages.EmploymentFirstHolderComponent},
      {path: 'personal-info-complete-first-holder', outlet: 'stages', component: stages.PersonalInfoCompleteFirstHolderComponent},
      {path: 'personal-second-holder', outlet: 'stages', component: stages.PersonalSecondHolderComponent},
      {path: 'address-second-holder', outlet: 'stages', component: stages.AddressSecondHolderComponent},
      {path: 'employment-second-holder', outlet: 'stages', component: stages.EmploymentSecondHolderComponent},
      {path: 'personal-info-complete', outlet: 'stages', component: stages.PersonalInfoCompleteComponent},
      {path: 'experience', outlet: 'stages', component: stages.ExperienceComponent},
      {path: 'source-of-wealth', outlet: 'stages', component: stages.SourceOfWealthComponent},
      {path: 'experience-info-complete', outlet: 'stages', component: stages.ExperienceInfoCompleteComponent},
      {path: 'regulatory', outlet: 'stages', component: stages.RegulatoryComponent},
      {path: 'investment', outlet: 'stages', component: stages.InvestmentComponent},
      {path: 'substitute', outlet: 'stages', component: stages.SubstituteSingleComponent},
      {path: 'substitute-first-holder', outlet: 'stages', component: stages.SubstituteFirstHolderComponent},
      {path: 'substitute-second-holder', outlet: 'stages', component: stages.SubstituteSecondHolderComponent},
      {path: 'general-agreement', outlet: 'stages', component: stages.GeneralAgreementComponent},
      {path: 'documents', outlet: 'stages', component: stages.DocumentsSingleComponent},
      {path: 'documents-first-holder', outlet: 'stages', component: stages.DocumentsFirstHolderComponent},
      {path: 'documents-second-holder', outlet: 'stages', component: stages.DocumentsSecondHolderComponent},
    ]
  },
  {
    path: 'documentview',
    component: DocumentViewerComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class WsRoutingModule {
}
